import React from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import StatusCircle from '../../graphics/StatusCircle';
import Circle from '../../graphics/Circle';
import colors from '../../../branding/defaultTheme/colors';
const RadioCircle = ({ isSelected, isHovered, isFocused, styles, disabled, status = 'success' }) => {
    const { inputs: { choiceStyles } } = useTheme();
    const marginStyles = useComponentMargin({ marginVertical: 'small', marginRight: 'small' });
    const mergedStyles = {
        ...marginStyles,
        ...(isFocused && !isHovered && choiceStyles.focused),
        ...styles
    };
    return isSelected ? (React.createElement(StatusCircle, { status: status, size: "tiny", styles: { ...mergedStyles }, disabled: disabled })) : (React.createElement(Circle, { colorOverride: colors.neutrals.textGamma, inverted: true, size: "tiny", styles: { ...mergedStyles }, disabled: disabled }));
};
export default RadioCircle;
//# sourceMappingURL=index.js.map